import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useInviteCodes() {
  const queryClient = useQueryClient();

  const { data: codes, isLoading, error, refetch } = useQuery({
    queryKey: ['admin', 'invite-codes'],
    queryFn: api.getInviteCodes,
    staleTime: 30 * 1000, // 30 seconds
  });

  const generateMutation = useMutation({
    mutationFn: api.generateInviteCode,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'invite-codes'] });
    },
  });

  return {
    codes,
    isLoading,
    error,
    refetch,
    generateCode: generateMutation.mutateAsync,
    isGenerating: generateMutation.isPending,
  };
}

export function useAdminUsers() {
  const { data: users, isLoading, error, refetch } = useQuery({
    queryKey: ['admin', 'users'],
    queryFn: api.getAdminUsers,
    staleTime: 30 * 1000, // 30 seconds
  });

  return {
    users,
    isLoading,
    error,
    refetch,
  };
}

export function useCleanup() {
  const cleanupRequestsMutation = useMutation({
    mutationFn: (days: number) => api.cleanupRequests(days),
  });

  const cleanupHistoryMutation = useMutation({
    mutationFn: (days: number) => api.cleanupHistory(days),
  });

  return {
    cleanupRequests: cleanupRequestsMutation.mutateAsync,
    isCleaningRequests: cleanupRequestsMutation.isPending,
    cleanupRequestsResult: cleanupRequestsMutation.data,

    cleanupHistory: cleanupHistoryMutation.mutateAsync,
    isCleaningHistory: cleanupHistoryMutation.isPending,
    cleanupHistoryResult: cleanupHistoryMutation.data,
  };
}
